import SEOArticleLayout from "@/components/feature/SEOArticleLayout";

const IMAGE = "https://readdy.ai/api/search-image?query=Close-up%20of%20padlock%20and%20shield%20icon%20on%20warm%20cream%20surface%20with%20soft%20natural%20lighting%2C%20cybersecurity%20concept%2C%20minimal%20clean%20composition%2C%20trust%20and%20safety%20aesthetic%2C%20warm%20oak%20and%20ivory%20tones%2C%20professional%20photography&width=900&height=1100&seq=seo-article-securite-v3&orientation=portrait";

export default function SecuritePage() {
  return (
    <SEOArticleLayout
      title="Sécurité et Confidentialité du Hipobuy Spreadsheet"
      subtitle="Comment le hipobuy spreadsheet protège vos données e-commerce. Tout sur la sécurité, le chiffrement et les mesures de confidentialité mises en place."
      heroImageUrl={IMAGE}
      heroImageAlt="Sécurité et confidentialité Hipobuy Spreadsheet"
    >
      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">La sécurité avant tout</h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
          Dans l'e-commerce, les données produits et les informations de vente sont sensibles. Le <strong>hipobuy spreadsheet</strong> place la sécurité au cœur de son architecture. Toutes les données sont protégées par des protocoles de chiffrement avancés et des mesures de sécurité conformes aux standards internationaux.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Mesures de sécurité du Hipobuy Spreadsheet</h2>
        <div className="space-y-3">
          {[
            { title: "Chiffrement des données", desc: "Toutes les données transitant par le hipobuy spreadsheet sont chiffrées avec des protocoles SSL/TLS de niveau bancaire." },
            { title: "Authentification sécurisée", desc: "Accès protégé par des mécanismes d'authentification robustes pour empêcher toute intrusion non autorisée." },
            { title: "Sauvegarde automatique", desc: "Vos données sont sauvegardées régulièrement et automatiquement. Aucun risque de perte d'information." },
            { title: "Confidentialité des données", desc: "Le hipobuy spreadsheet ne partage jamais vos données avec des tiers. Votre catalogue reste votre propriété exclusive." },
            { title: "Conformité RGPD", desc: "Respect du Règlement Général sur la Protection des Données pour les utilisateurs européens." },
          ].map((item, i) => (
            <div key={i} className="flex items-start gap-3 p-3 bg-background-100 rounded-xl">
              <i className="ri-shield-check-line text-primary-500 text-lg flex-shrink-0 mt-0.5"></i>
              <div>
                <h4 className="text-sm font-semibold text-foreground-950">{item.title}</h4>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-10">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">Vos données vous appartiennent</h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
          Un principe fondamental du <strong>hipobuy spreadsheet</strong> : vous restez propriétaire de vos données. Vous pouvez les exporter à tout moment dans des formats standards. Aucune dépendance forcée : votre catalogue et vos analyses vous suivent où que vous alliez.
        </p>
      </section>

      <div className="mt-8 p-6 bg-accent-50 rounded-2xl border border-accent-100 text-center">
        <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">En savoir plus</h3>
        <p className="text-sm text-foreground-500 mb-4">Visitez la plateforme officielle pour la documentation complète sur la sécurité du hipobuy spreadsheet.</p>
        <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-semibold uppercase tracking-wider whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer">
          Accéder à la Plateforme
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </SEOArticleLayout>
  );
}